import { useQuery } from "@tanstack/react-query";
import { fetchPackages, fetchPackage } from "../lib/api";

export const usePackages = (type) =>
  useQuery({
    queryKey: ["packages", type || "all"],
    queryFn: () => fetchPackages(type),
  });

export const usePackage = (slug) =>
  useQuery({
    queryKey: ["package", slug],
    queryFn: () => fetchPackage(slug),
    enabled: !!slug,
  });
